/* eslint-disable camelcase */
export const en_us = {
    values: {
        Home: 'Home',
        'Home Page': 'Home Page'
    }
}
